declare const mxUtils: any;

import {ShapeCommand} from '../commands.template';
import {ConnectorJson} from './connector.commands';

export class ConnectorCreateCommand extends ShapeCommand {
  // protected firstAction: boolean;
  protected services: any;

  constructor(
    data: ConnectorJson,
    private readonly type: 'connector' | 'terminator'
  ) {
    super(data);
  }

  public execute() {
    super.execute();

    const graph = this.services.editorRegistrySvc.getGraph();

    let insertedVertex;

    graph.model.beginUpdate();

    if (this.isConnector()) {
      insertedVertex = this.services.shapeSpawnerSvc.createConnector(
        this.object,
        this.object.flowlineMxKey
      );
    } else {
      insertedVertex = this.services.shapeSpawnerSvc.createTerminator(this.object);
    }

    graph.addCell(insertedVertex, this.services.graphHelperSvc.connectorAndTerminatorParent());
    this.object.mxKey = Number(insertedVertex.id);

    this.services.angularCompSvc.setCache(insertedVertex.id, insertedVertex.comp);

    const flowlineCell = this.services.graphHelperSvc
      .allFlowlines()
      .find(cell => Number(cell.id) === Number(this.object.flowlineMxKey));

    flowlineCell.skipUndo = true;
    const terminalPrefix = !flowlineCell.target ? 'entry' : 'exit';

    const srcType = flowlineCell.target ? this.type : null;
    const tgtType = flowlineCell.target ? null : this.type;

    graph.model.setTerminal(flowlineCell, insertedVertex, !!flowlineCell.target);
    graph.model.setStyle(
      flowlineCell,
      <string>(
        mxUtils.setStyle(
          flowlineCell.style,
          `${terminalPrefix}X`,
          this.object.newConnectionTerminalPoint[0]
        )
      )
    );
    graph.model.setStyle(
      flowlineCell,
      <string>(
        mxUtils.setStyle(
          flowlineCell.style,
          `${terminalPrefix}Y`,
          this.object.newConnectionTerminalPoint[1]
        )
      )
    );

    graph.selectionModel.addCell(insertedVertex);

    const query = <ConnectorJson>{
      mxKey: Number(this.object.mxKey),
      flowlineMxKey: Number(this.object.flowlineMxKey),
      position: {
        x: insertedVertex.geometry.x,
        y: insertedVertex.geometry.y,
        w: insertedVertex.geometry.width,
        h: insertedVertex.geometry.height
      }
    };

    if (srcType) {
      query.srcType = srcType;
    } else {
      query.tgtType = tgtType;
    }

    if (this.isConnector()) {
      this.services.flAssocSvc.copy(insertedVertex);
    }

    this.executeJson(query);
    graph.model.endUpdate();

    return insertedVertex;
  }

  public reverse() {
    super.reverse();
    const graph = this.services.editorRegistrySvc.getGraph();
    const insertedVertex = this.services.graphHelperSvc
      .allConnectorAndTerminators()
      .find(cell => Number(cell.id) === Number(this.object.mxKey));
    // const groupUpdate = this.services.diagramUpdateSvc.group();

    // groupUpdate.add();

    const flowlineCell = this.services.graphHelperSvc
      .allFlowlines()
      .find(cell => Number(cell.id) === Number(this.object.flowlineMxKey));
    // graph.model.beginUpdate();

    flowlineCell.skipUndo = true;

    // graph.model.beginUpdate();

    this.services.angularCompSvc.destroyComponent(insertedVertex);
    graph.removeCells([insertedVertex], false);

    // return groupUpdate.sendGroup();
    this.reverseJson(this.object);
  }

  private reverseJson(data: ConnectorJson) {
    return this.services.diagramUpdateSvc.update({
      [this.isConnector() ? 'deleteConnector' : 'deleteTerminator']: {
        flowlineMxKey: Number(data.flowlineMxKey)
      }
    });
  }

  private executeJson(data: ConnectorJson) {
    return this.services.diagramUpdateSvc.update({
      [this.isConnector() ? 'addConnector' : 'addTerminator']: data
    });
  }

  private isConnector() {
    return this.type === 'connector';
  }
}
